import type { NotificationItem } from '@/api/backend/contract/Notification';

export interface NotificationDateGroup {
  dateKey: string;
  date: Date;
  items: NotificationItem[];
}

export function groupNotificationsByDate(
  notifications: NotificationItem[]
): NotificationDateGroup[] {
  const groups = new Map<string, NotificationDateGroup>();

  const sorted = [...notifications].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  for (const item of sorted) {
    const date = new Date(item.createdAt);
    const dateKey = [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0')
    ].join('-');

    const group = groups.get(dateKey);

    if (group) {
      group.items.push(item);
      continue;
    }

    groups.set(dateKey, {
      dateKey,
      date,
      items: [item]
    });
  }

  return [...groups.values()];
}
